/**
 * Canonical material photos served by backendlaser at /materials/{id}-{slug}.jpg
 * Keep in sync with backendlaser/public/materials/ and scripts/reprocessMaterialPhotos.py
 */

/** @returns {string} Path relative to site root, e.g. /materials/11-orange-bone.jpg */
export function backendMaterialPath(materialId, slug) {
  const fileSlug = slug.replace(/_/g, '-');
  return `/materials/${materialId}-${fileSlug}.jpg`;
}

/**
 * Catalog entries matching processed photos on the backend.
 * shape: DB shape name (Bone | Square | Circle | Hex)
 */
export const BACKEND_MATERIAL_ENTRIES = [
  { materialId: 1, slug: 'yellow_square', shape: 'Square', colorHex: '#fbbf24' },
  { materialId: 2, slug: 'orange_circle', shape: 'Circle', colorHex: '#ea580c', stock: false },
  { materialId: 3, slug: 'red_circle', shape: 'Circle', colorHex: '#dc2626' },
  { materialId: 4, slug: 'grey_bone', shape: 'Bone', colorHex: '#6b7280' },
  { materialId: 5, slug: 'light_purple_hex', shape: 'Hex', colorHex: '#c084fc' },
  { materialId: 6, slug: 'light_pink_bone', shape: 'Bone', colorHex: '#f9a8d4' },
  { materialId: 7, slug: 'turquoise_square', shape: 'Square', colorHex: '#14b8a6' },
  { materialId: 8, slug: 'dark_blue_bone', shape: 'Bone', colorHex: '#1e3a8a' },
  { materialId: 9, slug: 'orange_square', shape: 'Square', colorHex: '#ea580c', stock: false },
  { materialId: 10, slug: 'light_blue_circle', shape: 'Circle', colorHex: '#7dd3fc' },
  { materialId: 11, slug: 'orange_bone', shape: 'Bone', colorHex: '#ea580c' },
  { materialId: 12, slug: 'grey_square', shape: 'Square', colorHex: '#6b7280' },
  { materialId: 13, slug: 'white_circle', shape: 'Circle', colorHex: '#ffffff' },
  { materialId: 14, slug: 'white_hex', shape: 'Hex', colorHex: '#ffffff' },
  { materialId: 15, slug: 'pink_hex', shape: 'Hex', colorHex: '#ec4899' },
  { materialId: 16, slug: 'turquoise_hex', shape: 'Hex', colorHex: '#14b8a6' },
  { materialId: 17, slug: 'white_on_blue_bone', shape: 'Bone', colorHex: '#3b82f6' },
  { materialId: 18, slug: 'yellow_bone', shape: 'Bone', colorHex: '#fbbf24' },
  { materialId: 19, slug: 'light_blue_hex', shape: 'Hex', colorHex: '#7dd3fc' },
  { materialId: 20, slug: 'purple_square', shape: 'Square', colorHex: '#9333ea' },
  { materialId: 21, slug: 'purple_bone', shape: 'Bone', colorHex: '#9333ea' },
  { materialId: 22, slug: 'pink_square', shape: 'Square', colorHex: '#ec4899' },
  { materialId: 23, slug: 'light_purple_square', shape: 'Square', colorHex: '#c084fc' },
  { materialId: 24, slug: 'red_square', shape: 'Square', colorHex: '#dc2626' },
  { materialId: 25, slug: 'lime_green_square', shape: 'Square', colorHex: '#16a34a' },
  { materialId: 26, slug: 'yellow_circle', shape: 'Circle', colorHex: '#fbbf24' },
];

const DB_SHAPE_TO_INVENTORY_KEY = {
  Bone: 'bone',
  Square: 'rect',
  Circle: 'circ',
  Hex: 'hex',
  Hexagon: 'hex',
};

export function backendEntriesAsApiMaterials() {
  return BACKEND_MATERIAL_ENTRIES.map((entry) => ({
    id: entry.materialId,
    shape: entry.shape,
    imageurl: backendMaterialPath(entry.materialId, entry.slug),
    colorhex: entry.colorHex,
    instockcount: entry.stock === false ? 0 : 1,
    in_back_order: false,
  }));
}

export function buildStaticInventoryFromBackend() {
  const inventory = { bone: [], circ: [], rect: [], hex: [] };

  BACKEND_MATERIAL_ENTRIES.forEach((entry) => {
    const shapeKey = DB_SHAPE_TO_INVENTORY_KEY[entry.shape];
    if (!shapeKey) return;

    const slugKey = entry.slug.replace(/_/g, '-');
    inventory[shapeKey].push({
      id: `mat-${entry.materialId}`,
      materialId: entry.materialId,
      color: entry.slug
        .replace(/_(bone|circle|square|hex)$/, '')
        .split('_')
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' '),
      colorHex: entry.colorHex,
      imagePath: backendMaterialPath(entry.materialId, entry.slug),
      stock: entry.stock !== false,
    });
  });

  return inventory;
}
